<template>
    <v-navigation-drawer
      :value="this.value"
      @input="handleInput"
      absolute
      temporary
    >
      <v-list
        nav
        dense
        style="cursor: pointer"
      >
          <v-list-item
          v-if="!this.$route.path.includes('/add')"
          @click="$router.push('/add')"
          >
            <v-list-item-icon>
              <v-icon>mdi-star-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Avaliar</v-list-item-title>
          </v-list-item>
          <v-list-item
          v-if="!this.$route.path.includes('/movies')"
          id="Novie" @click="$router.push(`/movies/${user.uid}`)"
          >
            <v-list-item-icon>
              <v-icon>mdi-monitor-cellphone-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
                Sua página
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="openModalMovieHelp"
          >
            <v-list-item-icon>
              <v-icon>mdi-help-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Ajuda</v-list-item-title>
          </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>

<script>

export default {
  name: 'NavMenu',
  props: ['value'],
  data() {
    return {
      content: this.value,
    };
  },
  created() {
    this.$auth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
  methods: {
    openModalMovieHelp() {
      this.$emit('onOpenModalHelp');
    },
    handleInput(e) {
      this.$emit('input', e);
    },
  },
};
</script>
